import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { BottomSheetComponent } from 'src/app/shared/bottom-sheet/bottom-sheet.component';
import { Requests } from 'src/app/shared/models/Requests';
import { RequestStatus } from 'src/app/shared/models/RequestsStatusEnum';
import { LetterOfCreditService } from 'src/app/shared/services/letter-of-credit/letter-of-credit.service';
import { TranslationConstants } from 'src/app/shared/services/util/translation.constants';

@Component({
    selector: 'app-panel',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss']
})
export class PanelComponent implements OnInit {
    public loading: boolean;
    public filteredStatus: string = 'ALL';
    public statusList: Array<string> = ['ALL','STARTED','ANALYSING', 'RETURNED', 'APPROVED', 'DENIED'];

    public displayedColumns: Array<string> = ['number', 'date', 'currentValue', 'status', 'analyst', 'actionsColumn1icon' ];
    public tableDataSource: Array<Requests> = [];
    public dataSource: MatTableDataSource<Requests>;

    constructor(
        private readonly router: Router,
        private readonly bottomSheet: MatBottomSheet,
        private readonly translationConstants: TranslationConstants,
        private readonly letterOfCreditService: LetterOfCreditService
    ) { }

    public ngOnInit(): void {
        this.loading = true;
        this.letterOfCreditService.getRequests().subscribe(letters => {
            if (letters) {
                this.tableDataSource = letters;
            }
        }).add(() => {
            this.dataSource = new MatTableDataSource<Requests>(this.tableDataSource);
            this.loading = false;
        });
    }

    public search(searchValue?: string): void {
        let search = '';
        let status: any = this.filteredStatus;

        if (searchValue) {
            search = searchValue;
        }

        if (status == 'ALL') {
            this.dataSource.data = this.tableDataSource ? this.tableDataSource.filter(letter =>
                letter?.id?.includes(search) || letter?.valueRequested?.toString().includes(search) || letter?.analist?.includes(search)) : [];
        } else {
            this.dataSource.data = this.tableDataSource ? this.tableDataSource.filter(letter =>
                letter?.currentStatus == status && (letter?.id?.includes(search) || letter?.valueRequested?.toString().includes(search) || letter?.analist?.includes(search))) : [];
        }

    }

    public newRequest(): void {
        const openedRequest = this.dataSource.data.filter(letter => letter.currentStatus === RequestStatus.S);
        if (openedRequest.length > 0) {
            const sheetRef: any =  this.bottomSheet.open(BottomSheetComponent, {
                data: {
                    text: this.translationConstants.translate('creditLetter.bottomSheet.message'),
                    declineOption: this.translationConstants.translate('creditLetter.bottomSheet.cancel'),
                    confirmOption: this.translationConstants.translate('creditLetter.bottomSheet.yes'),
                }
            });
            sheetRef.afterDismissed().subscribe( action => {
              if (action) {
                  this.router.navigate(['/credit-conversion/new']);
            }});
        } else {
            this.router.navigate(['/credit-conversion/new']);
        }
    }

    public editRequisition(letterNumber: number): void {
        this.router.navigate([`/credit-conversion/edit/${letterNumber}`])
    }

    public viewLetter(letterNumber: number): void {
        this.router.navigate([`/credit-conversion/view/${letterNumber}`])
    }
}
